"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StickyPositionType;
(function (StickyPositionType) {
    StickyPositionType[StickyPositionType["Both"] = 0] = "Both";
    StickyPositionType[StickyPositionType["Header"] = 1] = "Header";
    StickyPositionType[StickyPositionType["Footer"] = 2] = "Footer";
})(StickyPositionType = exports.StickyPositionType || (exports.StickyPositionType = {}));
//# sourceMappingURL=Sticky.types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Sticky/Sticky.types.js
// module id = 1203
// module chunks = 0